<template>
  <div id="register-component">
    <div class="va-row">
      <div class="flex md12 xs12">
        <div v-if="isLoading">
          <spring-spinner slot="loading" :animation-duration="2500" :size="70" />
        </div>
        <vuestic-widget v-if="!isLoading" :headerText="$t(`companies.register.title`)">
          <slot name="register-form">
            <div class="flex md4 offset--md4">
              <!-- Company name -->
              <div class="form-group">
                <div class="input-group">
                  <input
                    v-model="companyName"
                    id="company-name"
                    required
                    data-vv-name="companyName"
                    v-validate="'required'"
                  />
                  <label
                    class="control-label required-field-label"
                    for="company-name"
                  >{{'companies.register.clientName' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('companyName')"
                    class="help text-danger"
                  >{{ errors.first('companyName') != null ? errors.first('companyName').replace('companyName',$t('companies.register.clientName').toUpperCase()) : "" }}</small>
                </div>
              </div>

              <!-- EIK -->
              <div class="form-group">
                <div class="input-group">
                  <input
                    id="eik"
                    type="text"
                    v-model="companyNumber"
                    data-vv-name="companyNumber"
                    v-validate="'numeric|required|max:15'"
                    required
                  />
                  <label
                    class="control-label required-field-label"
                    for="eik"
                  >{{'companies.register.eik' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('companyNumber')"
                    class="help text-danger"
                  >{{ errors.first('companyNumber') != null ? errors.first('companyNumber').replace('companyNumber',$t('companies.register.eik').toUpperCase()) : "" }}</small>
                </div>
              </div>

              <!-- vat -->
              <div class="form-group">
                <div class="input-group">
                  <input
                    id="vat"
                    type="text"
                    v-model="companyVatNumber"
                    data-vv-name="companyVatNumber"
                    required
                  />
                  <label
                    class="control-label"
                    for="vat"
                  >{{'companies.register.vat' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('companyVatNumber')"
                    class="help text-danger"
                  >{{ errors.first('companyVatNumber') != null ? errors.first('companyVatNumber').replace('companyVatNumber',$t('companies.register.vat').toUpperCase()) : "" }}</small>
                </div>
              </div>

              <!-- Password -->
              <div class="va-row form-group">
                <div class="input-group flex md9 password-wrapper">
                  <input
                    id="pass"
                    type="text"
                    data-vv-name="password"
                    v-validate="'length:6|max:11|required'"
                    v-model="password"
                    readonly="true"
                    required
                  />
                  <label
                    id="pass-label"
                    class="control-label"
                    for="pass"
                  >{{'companies.register.password' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('password')"
                    class="help text-danger"
                  >{{ errors.first('password') != null ? errors.first('password').replace('password',$t('companies.register.password').toUpperCase()) : "" }}</small>
                </div>
                <button
                @click="password=generatePassword()"
                class="btn btn-primary btn-micro mb-4 flex md3"
                type="button"
              >{{ 'companies.register.generatePassword' | translate}}</button>
              </div>

              <!-- EMAIL -->
              <div class="form-group">
                <div class="input-group">
                  <input
                    v-model="companyEmail"
                    id="email"
                    required
                    data-vv-name="email"
                    v-validate="'emailValidation|max:30'"
                    data-vv-validate-on="blur"
                  />
                  <label
                    class="control-label"
                    for="email"
                  >{{'companies.register.email' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('email')"
                    class="help text-danger"
                  >{{ errors.first('email') != null ? errors.first('email').replace('email',$t('companies.register.email').toUpperCase()) : "" }}</small>
                </div>
              </div>

              <!-- address -->
              <div class="form-group">
                <div class="input-group">
                  <input v-model="companyAddress" id="address" required />
                  <label
                    class="control-label"
                    for="address"
                  >{{'companies.register.address' | translate}}</label>
                  <i class="bar"></i>
                </div>
              </div>

              <!-- reg button -->
              <div class="text-center">
                <button
                  @click="validateAndRegister"
                  class="btn btn-primary"
                  type="button"
                >{{ 'companies.register.regButton' | translate}}</button>
              </div>
            </div>
          </slot>
        </vuestic-widget>
      </div>
    </div>

    <vuestic-modal :show.sync="showModal" ref="modal">
      <div :class="modal.hasErrors ? 'text-danger':''" slot="title">{{modal.title}}</div>
      <div class="text-center pb-3">{{ $t('companies.register.qrHelperMessage' )}}</div>
      <qrcode-vue  v-show="modal.companyQRUrl!=''" :value="modal.companyQRUrl" :size="qrSettings.size" :class="qrSettings.class"></qrcode-vue>
      <div class="text-center" :class="modal.hasErrors ? 'text-danger':''">{{modal.companyQRUrl}}</div>
      <div class="text-center" :class="modal.hasErrors ? 'text-danger':''">{{modal.text}}</div>
      <div slot="footer" class="va-row">
        <button
          type="button"
          class="btn btn-primary flex md5"
          @click="refreshView"
        >{{ $t('companies.register.newFirm') }}</button>
        <div class="flex md1"></div>
        <button
          type="button"
          class="btn btn-primary flex md5"
          @click="navigateToAll"
        >{{ $t('companies.register.toAllClients') }}</button>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { companiesApi } from '../../../services/api/companiesApi'
import PasswordField from '../../ui/password-field/PasswordField'
import { createNamespacedHelpers } from 'vuex'
import SpringSpinner from 'epic-spinners/src/components/lib/SpringSpinner'
import { QRURL } from '../../../helpers'
const { mapGetters } = createNamespacedHelpers('app')

export default {
  name: 'register',
  components: {
    PasswordField,
    SpringSpinner,
    QrcodeVue
  },
  mounted () {
    // this.$validator.extend("checkEikUnique", {
    //   getMessage: field => this.$t("errors.eikRegistered"),
    //   validate: value => {
    //     return companiesApi
    //       .checkEikUnique(value)
    //       .then(response => {
    //         if (response) {
    //           return Promise.resolve(response);
    //         } else {
    //           return Promise.reject(response);
    //         }
    //       })
    //       .catch(error => {
    //         return { error: response.error.val };
    //       });
    //   }
    // });
    this.password = this.generatePassword()
  },
  computed: {
    ...mapGetters(['isLoading'])
  },
  watch: {
    companyNumber () {
      this.companyVatNumber = `BG${this.companyNumber}`
    }
  },
  data () {
    return {
      companyNumber: '',
      companyName: '',
      companyEmail: '',
      password: '',
      companyVatNumber: '',
      companyAddress: '',
      showModal: false,
      modal: {
        hasErrors: false,
        title: '',
        text: '',
        companyQRUrl: ''
      },
      qrSettings: {
        size: 150,
        class: 'text-center'
      }
    }
  },
  methods: {
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    validateFormField (fieldName) {
      this.$validator.validate(fieldName, this[fieldName])
    },
    validateAndRegister () {
      this.$validator.validateAll().then(() => {
        return this._register()
      })
    },
    generatePassword () {
      return Math.floor(100000 + Math.random() * 900000)
    },
    async _register () {
      let companyToCreate = {
        companyNumber: this.companyNumber,
        companyName: this.companyName,
        password: this.password !== '' ? this.password : this.generatePassword(),
        companyVatNumber: this.companyVatNumber
      }
      if (this.companyEmail !== '') { companyToCreate.companyEmail = this.companyEmail }
      if (this.companyAddress !== '') { companyToCreate.companyAddress = this.companyAddress }

      try {
        let companyInfo = await companiesApi.create(companyToCreate)
        console.log('success')
        this.modal.companyQRUrl = QRURL(companyInfo.number, companyInfo.pin.slice(0, 3), companyInfo.pin.slice(3))
        this.modal.title = this.$t('companies.register.regSuccessTitle')
        this.modal.hasErrors = false
      } catch (err) {
        this.modal.title = this.$t('companies.register.regErrorTitle')
        this.modal.text = this.$t(`companies.register.errors.${err.code}`)
        this.modal.hasErrors = true
      }
      this.$refs.modal.open()
    },
    refreshView () {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.$data.modal = {
        hasErrors: false,
        title: '',
        text: ''
      }
      this.$nextTick(() => {
        this.$validator.reset()
        this.$refs.modal.close()
      })
    },
    navigateToAll () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss">
#register-component {
  .required-field-label::after {
    color: red;
    content: " *";
  }

  #pass-label{
    font-size: 0.6rem;
    color: #ffcece;
    font-weight: 600;
    text-transform: uppercase;
    top: -0.6rem;
    left: 0;
    padding: 0.5rem;
  }
}
</style>
